import {Platform, useWindowDimensions} from 'react-native';
import {ITheme} from 'contexts/ThemeContext';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default ({colors, typography}: ITheme) => {
  const height = useWindowDimensions().height;

  return CreateResponsiveStyle(
    {
      containerStyle: {
        flex: 1,
        backgroundColor: colors.dirtyWhite,
      },
      containerWeb: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: height / 5,
      },
      logoWebStyle: {
        width: 100,
        height: 100,
      },
      contentContainerWeb: {
        width: 461,
        height: 634,
        borderRadius: 40,
        backgroundColor: colors.cornflowerBlue,
        alignItems: 'center',
        paddingTop: 88,
        paddingBottom: 88,
      },
      heroImageWeb: {
        opacity: 0.6,
        position: 'absolute',
        right: 25,
        bottom: 25,
        width: height / 2,
        height: height / 2,
      },
      safeAreaStyle: {
        flex: 1,
        width: '100%',
      },
      leftEllipseStyle: {
        position: 'absolute',
        top: 0,
        left: 0,
      },
      leftEllipseImageStyle: {
        width: 138,
        height: 290,
      },
      contentContainerStyle: {
        flex: 1,
        alignItems: 'center',
      },
      titleStyle: {},
      subTitleStyle: {
        marginBottom: 51,
        fontSize: 22,
        width: 250,
        textAlign: 'center',
        lineHeight: 24.93,
        letterSpacing: -0.41,
        color: colors.primaryTextColor,
        ...typography.notoSansMedium,
      },
      imageContainerStyle: {
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
      },
      heroImageStyle: {
        elevation: 1,
      },
      heroImage: {
        width: 255,
        height: 298,
      },
      rightEllipseStyle: {
        position: 'absolute',
        bottom: -60,
        right: 0,
        zIndex: -1,
      },
      rightEllipseImageStyle: {
        width: 133,
        height: 351,
      },
      ...Platform.select({
        ios: {
          titleStyle: {
            marginTop: 40,
            marginBottom: 22,
            ...typography.mulishBold,
            fontSize: 66,
            lineHeight: 82.83,
            letterSpacing: -0.41,
            color: colors.primaryTextColor,
          },
        },
        android: {
          titleStyle: {
            marginTop: 22,
            marginBottom: 22,
            ...typography.mulishBold,
            fontSize: 66,
            lineHeight: 82.83,
            letterSpacing: -0.41,
            color: colors.primaryTextColor,
          },
        },
        web: {
          titleStyle: {
            marginTop: 28,
            fontSize: 80,
            lineHeight: 125,
            letterSpacing: -0.41,
            color: colors.primaryTextColor,
            ...typography.mitr,
          },
          subTitleStyle: {
            marginBottom: 68,
            fontSize: 22,
            width: 250,
            textAlign: 'center',
            lineHeight: 24.93,
            letterSpacing: -0.41,
            color: colors.primaryTextColor,
            ...typography.notoSansMedium,
          },
        },
      }),
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        titleStyle: {
          color: colors.white,
        },
        subTitleStyle: {
          color: colors.white,
        },
      },
    },
  )();
};
